import React from 'react';
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer
      style={{
        background: '#777',
        color: 'white',
        padding: '40px 20px',
        fontFamily: 'Roboto',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '40px'
        }}
      >
        {/* Sevenky Overview */}
        <div style={{ flex: '1 1 300px' }}>
          <h3 style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '20px' }}>Sevenky Technologies</h3>
          <p>
            We provide innovative solutions to engineering and business use-cases,
            developing real-time, low-cost, and highly reliable smart products,
            along with corporate training in technology and management.
          </p>
        </div>

        {/* Quick Links */}
        <div style={{ flex: '1 1 150px' }}>
          <h3 style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '20px' }}>Quick Links</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {['About', 'Services', 'Portfolio', 'Team', 'Contact'].map((item, index) => (
              <li key={index} style={{ marginBottom: '10px' }}>
                <a href={`#${item.toLowerCase().replace(/\s+/g, '')}`} style={{ color: 'white', textDecoration: 'none' }}>
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div style={{ flex: '1 1 200px' }}>
          <h3 style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '20px' }}>Contact</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li>6-19-4/1, East Point Colony</li>
            <li>Visakhapatnam 530017</li>
            <li>
              <a href="mailto:contact@sevenky.com" style={{ color: 'white', textDecoration: 'none' }}>
                contact@sevenky.com
              </a>
            </li>
            <li>
              <a href="tel:+918826375929" style={{ color: 'white', textDecoration: 'none' }}>
                +91-8826375929
              </a>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div style={{ flex: '1 1 300px' }}>
          <h3 style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '20px' }}>Newsletter</h3>
          <p>Subscribe to receive our updates</p>
          <form style={{ marginTop: '10px' }}>
            <input
              type="email"
              placeholder="Your email"
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '5px',
                border: 'none',
                marginBottom: '10px',
                fontSize: '18px'
              }}
            />
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '10px',
                background: 'white',
                color: '#007bff',
                border: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '18px',
                cursor: 'pointer'
              }}
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        style={{
          borderTop: '1px solid rgba(255,255,255,0.3)',
          marginTop: '40px',
          paddingTop: '20px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '1400px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <p style={{ margin: 0 }}>© 2025 Sevenky Technologies. All rights reserved.</p>
        <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
          <a href="#" style={{ color: 'white', fontSize: '24px' }}>
            <FaFacebookF />
          </a>
          <a href="https://twitter.com/7kyTech" target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '24px' }}>
            <FaTwitter />
          </a>
          <a href="https://www.linkedin.com/company/sevenky" target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '24px' }}>
            <FaLinkedinIn />
          </a>
          <a href="#" style={{ color: 'white', fontSize: '18px' }}>
            <FaInstagram />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
